// Cookie Consent Banner Component
// GDPR/CCPA compliant cookie consent banner

import { Button } from '@/components/ui/button';

const CookieConsentBanner = ({ onAccept, onDecline }) => {
  return (
    <div 
      className="absolute bottom-20 left-0 right-0 mx-4 bg-slate-800 text-white p-3 rounded-lg shadow-lg text-xs" 
      data-testid="cookie-banner"
    >
      <p className="mb-2">
        We use cookies to improve your experience. By continuing, you consent to our use of cookies.
      </p>
      <div className="flex gap-2">
        <Button
          size="sm"
          variant="secondary"
          className="flex-1 text-xs h-7 bg-white text-slate-800 hover:bg-slate-100"
          onClick={onAccept}
          data-testid="accept-cookies-btn"
        >
          Accept
        </Button>
        <Button
          size="sm"
          variant="ghost"
          className="flex-1 text-xs h-7 text-white hover:bg-white/10"
          onClick={onDecline}
          data-testid="decline-cookies-btn"
        >
          Decline
        </Button>
      </div>
    </div>
  );
};

export default CookieConsentBanner;
